'use client';

import { useTranslations } from 'next-intl';

import { Typography } from '@/components/atoms';
import { cn } from '@/lib/utils/tailwind';

import { ContentCard } from '../ContentCard';
import { RecommendationSectionProps } from './types';

const RecommendationSection = ({
  recommendedContent,
}: RecommendationSectionProps) => {
  const t = useTranslations();

  return (
    <section className="w-full overflow-hidden">
      {recommendedContent.length > 0 && (
        <>
          <Typography.Heading variant="h5" className="mx-4">
            {t('B2B_RECOMMENDATIONS_TITLE')}
          </Typography.Heading>
          <div className="flex flex-wrap gap-4">
            {recommendedContent.map(item => (
              <div
                key={item.id}
                className={cn(
                  item.contentType === 'video' ||
                    item.contentType === 'collection'
                    ? 'w-full sm:basis-[430px] sm:max-w-[430px]'
                    : 'w-full sm:basis-[250px] sm:max-w-[250px]',
                  'shrink-0',
                )}
              >
                <ContentCard
                  variant={item.variant}
                  contentType={item.contentType}
                  title={item.title}
                  description={item.description}
                  imageUrl={item.imageUrl}
                  slug={item.id.toString()}
                  className="w-full"
                />
              </div>
            ))}
          </div>
        </>
      )}
    </section>
  );
};

export { RecommendationSection };
